import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
var Popover = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$forceTop = _ref.forceTop,
      forceTop = _ref$forceTop === void 0 ? false : _ref$forceTop,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      props = _objectWithoutProperties(_ref, ["children", "forceTop", "style", "className"]);

  return React.createElement("div", Object.assign({
    style: _objectSpread({
      maxHeight: '400px'
    }, style, {
      top: forceTop || style.top
    }),
    className: classNames(className, ['color-mode-elevated', 'zindex-large position-absolute inline-block', 'radius-normal scroll-y', 'background-white border-none', 'shadow-hovering'])
  }, props, {
    ref: ref
  }), children);
});
export default Popover;